import { BdsGrid } from 'blip-ds/dist/blip-ds-react/components';
import { BubbleText } from 'components/BubbleText';
import { Label } from 'components/Label';
import { TicketMessage } from 'typings/components/TicketMessage';

type MessageFilterProps = {
    message: TicketMessage;
};

export const MessageFilter = ({ message }: MessageFilterProps) => {
    if (typeof message.content == 'string') {
        return (
            <div key={message.id}>
                <BubbleText message={message} />
            </div>
        );
    }
    if (message.content.sequentialId)
        return (
            <BdsGrid gap="1" alignItems="center" direction="column" key={message.id}>
                <Label bold="semi-bold" variant="fs-16" key={message.id}>
                    Conversa encaminhada para atendimento
                </Label>
                <Label bold="bold" variant="fs-20" key={message.id}>
                    Ticket #{message.content.sequentialId}
                </Label>
            </BdsGrid>
        );
    if (message.content.interactive?.type === 'button') {
        return (
            <div className="left-bubble">
                <Label paragraph={true} variant="fs-14">
                    {message.content.interactive.body.text}
                </Label>
                <BdsGrid gap="1" alignItems="center" direction="column" key={message.id}>
                    {message.content.interactive.action.buttons?.map((button, index) => (
                        <Label color="#1E6BF1" bold="semi-bold" variant="fs-16" key={index}>
                            {button.reply.title}
                        </Label>
                    ))}
                </BdsGrid>
            </div>
        );
    }
    return <span />;
};
